function e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var t = function () {
  var e;
  function t() {
    !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, t);
  }
  return e = [{
    key: "innerWidth",
    value: function value(e) {
      if (e) {
        var t = e.offsetWidth,
          n = getComputedStyle(e);
        return t + (parseFloat(n.paddingLeft) + parseFloat(n.paddingRight));
      }
      return 0;
    }
  }, {
    key: "width",
    value: function value(e) {
      if (e) {
        var t = e.offsetWidth,
          n = getComputedStyle(e);
        return t - (parseFloat(n.paddingLeft) + parseFloat(n.paddingRight));
      }
      return 0;
    }
  }, {
    key: "getWindowScrollTop",
    value: function value() {
      var e = document.documentElement;
      return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0);
    }
  }, {
    key: "getWindowScrollLeft",
    value: function value() {
      var e = document.documentElement;
      return (window.pageXOffset || e.scrollLeft) - (e.clientLeft || 0);
    }
  }, {
    key: "getOuterWidth",
    value: function value(e, t) {
      if (e) {
        var n = e.offsetWidth || e.getBoundingClientRect().width;
        if (t) {
          var i = getComputedStyle(e);
          n += parseFloat(i.marginLeft) + parseFloat(i.marginRight);
        }
        return n;
      }
      return 0;
    }
  }, {
    key: "getOuterHeight",
    value: function value(e, t) {
      if (e) {
        var n = e.offsetHeight || e.getBoundingClientRect().height;
        if (t) {
          var i = getComputedStyle(e);
          n += parseFloat(i.marginTop) + parseFloat(i.marginBottom);
        }
        return n;
      }
      return 0;
    }
  }, {
    key: "getClientHeight",
    value: function value(e, t) {
      if (e) {
        var n = e.clientHeight;
        if (t) {
          var i = getComputedStyle(e);
          n += parseFloat(i.marginTop) + parseFloat(i.marginBottom);
        }
        return n;
      }
      return 0;
    }
  }, {
    key: "getViewport",
    value: function value() {
      var e = window,
        t = document,
        n = t.documentElement,
        i = t.getElementsByTagName("body")[0];
      return {
        width: e.innerWidth || n.clientWidth || i.clientWidth,
        height: e.innerHeight || n.clientHeight || i.clientHeight
      };
    }
  }, {
    key: "getOffset",
    value: function value(e) {
      if (e) {
        var t = e.getBoundingClientRect();
        return {
          top: t.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
          left: t.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
        };
      }
      return {
        top: "auto",
        left: "auto"
      };
    }
  }, {
    key: "generateZIndex",
    value: function value() {
      return this.zindex = this.zindex || 999, ++this.zindex;
    }
  }, {
    key: "getCurrentZIndex",
    value: function value() {
      return this.zindex;
    }
  }, {
    key: "index",
    value: function value(e) {
      if (e) for (var t = e.parentNode.childNodes, n = 0, i = 0; i < t.length; i++) {
        if (t[i] === e) return n;
        1 === t[i].nodeType && n++;
      }
      return -1;
    }
  }, {
    key: "addMultipleClasses",
    value: function value(e, t) {
      if (e) {
        if (e.classList) for (var n = t.split(" "), i = 0; i < n.length; i++) e.classList.add(n[i]);else for (var o = t.split(" "), l = 0; l < o.length; l++) e.className += " " + o[l];
      }
    }
  }, {
    key: "addClass",
    value: function value(e, t) {
      e && (e.classList ? e.classList.add(t) : e.className += " " + t);
    }
  }, {
    key: "removeClass",
    value: function value(e, t) {
      e && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " "));
    }
  }, {
    key: "hasClass",
    value: function value(e, t) {
      if (e) return e.classList ? e.classList.contains(t) : RegExp("(^| )" + t + "( |$)", "gi").test(e.className);
    }
  }, {
    key: "find",
    value: function value(e, t) {
      return e ? Array.from(e.querySelectorAll(t)) : [];
    }
  }, {
    key: "findSingle",
    value: function value(e, t) {
      return e ? e.querySelector(t) : null;
    }
  }, {
    key: "getHeight",
    value: function value(e) {
      if (e) {
        var t = e.offsetHeight,
          n = getComputedStyle(e);
        return t - (parseFloat(n.paddingTop) + parseFloat(n.paddingBottom) + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth));
      }
      return 0;
    }
  }, {
    key: "getWidth",
    value: function value(e) {
      if (e) {
        var t = e.offsetWidth,
          n = getComputedStyle(e);
        return t - (parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) + parseFloat(n.borderLeftWidth) + parseFloat(n.borderRightWidth));
      }
      return 0;
    }
  }, {
    key: "alignOverlay",
    value: function value(e, n, i) {
      var o = !(arguments.length > 3) || void 0 === arguments[3] || arguments[3];
      e && n && ("self" === i ? this.relativePosition(e, n) : (o && (e.style.minWidth = t.getOuterWidth(n) + "px"), this.absolutePosition(e, n)));
    }
  }, {
    key: "absolutePosition",
    value: function value(e, t) {
      if (e) {
        var n,
          i,
          o = e.offsetParent ? {
            width: e.offsetWidth,
            height: e.offsetHeight
          } : this.getHiddenElementDimensions(e),
          l = o.height,
          r = o.width,
          a = t.offsetHeight,
          s = t.offsetWidth,
          u = t.getBoundingClientRect(),
          d = this.getWindowScrollTop(),
          c = this.getWindowScrollLeft(),
          f = this.getViewport();
        u.top + a + l > f.height ? ((n = u.top + d - l) < 0 && (n = d), e.style.transformOrigin = "bottom") : (n = a + u.top + d, e.style.transformOrigin = "top"), i = u.left + s + r > f.width ? Math.max(0, u.left + c + s - r) : u.left + c, e.style.top = n + "px", e.style.left = i + "px";
      }
    }
  }, {
    key: "relativePosition",
    value: function value(e, t) {
      if (e) {
        var n,
          i,
          o = e.offsetParent ? {
            width: e.offsetWidth,
            height: e.offsetHeight
          } : this.getHiddenElementDimensions(e),
          l = t.offsetHeight,
          r = t.getBoundingClientRect(),
          a = this.getViewport();
        r.top + l + o.height > a.height ? (n = -1 * o.height, r.top + n < 0 && (n = -1 * r.top), e.style.transformOrigin = "bottom") : (n = l, e.style.transformOrigin = "top"), i = o.width > a.width ? -1 * r.left : r.left + o.width > a.width ? -((r.left + o.width - a.width) * 1) : 0, e.style.top = n + "px", e.style.left = i + "px";
      }
    }
  }, {
    key: "flipfitCollision",
    value: function value(e, n) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "left top",
        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "left bottom",
        l = arguments.length > 4 ? arguments[4] : void 0,
        r = this,
        a = n.getBoundingClientRect(),
        s = this.getViewport(),
        u = i.split(" "),
        d = o.split(" "),
        c = function c(e, t) {
          return t ? +e.substring(e.search(/(\+|-)/g)) || 0 : e.substring(0, e.search(/(\+|-)/g)) || e;
        },
        f = {
          my: {
            x: c(u[0]),
            y: c(u[1] || u[0]),
            offsetX: c(u[0], !0),
            offsetY: c(u[1] || u[0], !0)
          },
          at: {
            x: c(d[0]),
            y: c(d[1] || d[0]),
            offsetX: c(d[0], !0),
            offsetY: c(d[1] || d[0], !0)
          }
        },
        h = {
          left: function left() {
            return +f.my.offsetX + +f.at.offsetX + a.left + ("left" === f.my.x ? 0 : -1 * ("center" === f.my.x ? r.getOuterWidth(e) / 2 : r.getOuterWidth(e)));
          },
          top: function top() {
            return +f.my.offsetY + +f.at.offsetY + a.top + ("top" === f.my.y ? 0 : -1 * ("center" === f.my.y ? r.getOuterHeight(e) / 2 : r.getOuterHeight(e)));
          }
        },
        g = {
          count: {
            x: 0,
            y: 0
          },
          left: function left() {
            var n = h.left(),
              i = t.getWindowScrollLeft();
            e.style.left = n + i + "px", 2 === this.count.x ? (e.style.left = i + "px", this.count.x = 0) : n < 0 && (this.count.x++, f.my.x = "left", f.at.x = "right", f.my.offsetX *= -1, f.at.offsetX *= -1, this.right());
          },
          right: function right() {
            var i = h.left() + t.getOuterWidth(n),
              o = t.getWindowScrollLeft();
            e.style.left = i + o + "px", 2 === this.count.x ? (e.style.left = s.width - t.getOuterWidth(e) + o + "px", this.count.x = 0) : i + t.getOuterWidth(e) > s.width && (this.count.x++, f.my.x = "right", f.at.x = "left", f.my.offsetX *= -1, f.at.offsetX *= -1, this.left());
          },
          top: function top() {
            var n = h.top(),
              i = t.getWindowScrollTop();
            e.style.top = n + i + "px", 2 === this.count.y ? (e.style.left = i + "px", this.count.y = 0) : n < 0 && (this.count.y++, f.my.y = "top", f.at.y = "bottom", f.my.offsetY *= -1, f.at.offsetY *= -1, this.bottom());
          },
          bottom: function bottom() {
            var i = h.top() + t.getOuterHeight(n),
              o = t.getWindowScrollTop();
            e.style.top = i + o + "px", 2 === this.count.y ? (e.style.left = s.height - t.getOuterHeight(e) + o + "px", this.count.y = 0) : i + t.getOuterHeight(n) > s.height && (this.count.y++, f.my.y = "bottom", f.at.y = "top", f.my.offsetY *= -1, f.at.offsetY *= -1, this.top());
          },
          center: function center(i) {
            if ("y" === i) {
              var o = h.top() + t.getOuterHeight(n) / 2;
              e.style.top = o + t.getWindowScrollTop() + "px", o < 0 ? this.bottom() : o + t.getOuterHeight(n) > s.height && this.top();
            } else {
              var l = h.left() + t.getOuterWidth(n) / 2;
              e.style.left = l + t.getWindowScrollLeft() + "px", l < 0 ? this.left() : l + t.getOuterWidth(e) > s.width && this.right();
            }
          }
        };
      g[f.at.x]("x"), g[f.at.y]("y"), this.isFunction(l) && l(f);
    }
  }, {
    key: "findCollisionPosition",
    value: function value(e) {
      if (e) return "top" === e || "bottom" === e ? {
        axis: "y",
        my: "center ".concat("top" === e ? "bottom" : "top"),
        at: "center ".concat(e)
      } : {
        axis: "x",
        my: "".concat("left" === e ? "right" : "left", " center"),
        at: "".concat(e, " center")
      };
    }
  }, {
    key: "getParents",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      return null === e.parentNode ? t : this.getParents(e.parentNode, t.concat([e.parentNode]));
    }
  }, {
    key: "getScrollableParents",
    value: function value(e) {
      var t = [];
      if (e) {
        var n = this.getParents(e),
          i = /(auto|scroll)/,
          o = !0,
          l = !1,
          r = void 0;
        try {
          for (var a, s = n[Symbol.iterator](); !(o = (a = s.next()).done); o = !0) {
            var u = a.value,
              d = 1 === u.nodeType && u.dataset.scrollselectors;
            if (d) {
              var c = d.split(","),
                f = !0,
                h = !1,
                g = void 0;
              try {
                for (var y, p = c[Symbol.iterator](); !(f = (y = p.next()).done); f = !0) {
                  var v = y.value,
                    m = this.findSingle(u, v);
                  m && function (e) {
                    var t = window.getComputedStyle(e, null);
                    return i.test(t.getPropertyValue("overflow")) || i.test(t.getPropertyValue("overflowX")) || i.test(t.getPropertyValue("overflowY"));
                  }(m) && t.push(m);
                }
              } catch (e) {
                h = !0, g = e;
              } finally {
                try {
                  f || null == p.return || p.return();
                } finally {
                  if (h) throw g;
                }
              }
            }
          }
        } catch (e) {
          l = !0, r = e;
        } finally {
          try {
            o || null == s.return || s.return();
          } finally {
            if (l) throw r;
          }
        }
      }
      return t;
    }
  }, {
    key: "getHiddenElementOuterHeight",
    value: function value(e) {
      if (e) {
        e.style.visibility = "hidden", e.style.display = "block";
        var t = e.offsetHeight;
        return e.style.display = "none", e.style.visibility = "visible", t;
      }
      return 0;
    }
  }, {
    key: "getHiddenElementOuterWidth",
    value: function value(e) {
      if (e) {
        e.style.visibility = "hidden", e.style.display = "block";
        var t = e.offsetWidth;
        return e.style.display = "none", e.style.visibility = "visible", t;
      }
      return 0;
    }
  }, {
    key: "getHiddenElementDimensions",
    value: function value(e) {
      var t = {};
      return e && (e.style.visibility = "hidden", e.style.display = "block", t.width = e.offsetWidth, t.height = e.offsetHeight, e.style.display = "none", e.style.visibility = "visible"), t;
    }
  }, {
    key: "fadeIn",
    value: function value(e, t) {
      if (e) {
        e.style.opacity = "0";
        var n = +new Date(),
          i = "0",
          o = function o() {
            i = "".concat(+e.style.opacity + (new Date().getTime() - n) / t), e.style.opacity = i, n = +new Date(), 1 > +i && (window.requestAnimationFrame && requestAnimationFrame(o) || setTimeout(o, 16));
          };
        o();
      }
    }
  }, {
    key: "fadeOut",
    value: function value(e, t) {
      if (e) var n = 1,
        i = 50 / t,
        o = setInterval(function () {
          (n -= i) <= 0 && (n = 0, clearInterval(o)), e.style.opacity = "".concat(n);
        }, 50);
    }
  }, {
    key: "getUserAgent",
    value: function value() {
      return navigator.userAgent;
    }
  }, {
    key: "isIOS",
    value: function value() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }
  }, {
    key: "isAndroid",
    value: function value() {
      return /(android)/i.test(navigator.userAgent);
    }
  }, {
    key: "isFunction",
    value: function value(e) {
      return !!(e && e.constructor && e.call && e.apply);
    }
  }, {
    key: "appendChild",
    value: function value(e, t) {
      if (this.isElement(t)) t.appendChild(e);else if (t.el && t.el.nativeElement) t.el.nativeElement.appendChild(e);else throw Error("Cannot append " + t + " to " + e);
    }
  }, {
    key: "removeChild",
    value: function value(e, t) {
      if (this.isElement(t)) t.removeChild(e);else if (t.el && t.el.nativeElement) t.el.nativeElement.removeChild(e);else throw Error("Cannot remove " + e + " from " + t);
    }
  }, {
    key: "isElement",
    value: function value(e) {
      return "object" == typeof HTMLElement ? e instanceof HTMLElement : e && "object" == typeof e && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName;
    }
  }, {
    key: "scrollInView",
    value: function value(e, t) {
      var n = getComputedStyle(e).getPropertyValue("borderTopWidth"),
        i = n ? parseFloat(n) : 0,
        o = getComputedStyle(e).getPropertyValue("paddingTop"),
        l = o ? parseFloat(o) : 0,
        r = e.getBoundingClientRect(),
        a = t.getBoundingClientRect().top + document.body.scrollTop - (r.top + document.body.scrollTop) - i - l,
        s = e.scrollTop,
        u = e.clientHeight,
        d = this.getOuterHeight(t);
      a < 0 ? e.scrollTop = s + a : a + d > u && (e.scrollTop = s + a - u + d);
    }
  }, {
    key: "clearSelection",
    value: function value() {
      if (window.getSelection) window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0 && window.getSelection().removeAllRanges();else if (document.selection && document.selection.empty) try {
        document.selection.empty();
      } catch (e) {}
    }
  }, {
    key: "calculateScrollbarWidth",
    value: function value(e) {
      if (e) {
        var t = getComputedStyle(e);
        return e.offsetWidth - e.clientWidth - parseFloat(t.borderLeftWidth) - parseFloat(t.borderRightWidth);
      }
      if (null != this.calculatedScrollbarWidth) return this.calculatedScrollbarWidth;
      var n = document.createElement("div");
      n.className = "p-scrollbar-measure", document.body.appendChild(n);
      var i = n.offsetWidth - n.clientWidth;
      return document.body.removeChild(n), this.calculatedScrollbarWidth = i, i;
    }
  }, {
    key: "getBrowser",
    value: function value() {
      if (!this.browser) {
        var e = this.resolveUserAgent();
        this.browser = {}, e.browser && (this.browser[e.browser] = !0, this.browser.version = e.version), this.browser.chrome ? this.browser.webkit = !0 : this.browser.webkit && (this.browser.safari = !0);
      }
      return this.browser;
    }
  }, {
    key: "resolveUserAgent",
    value: function value() {
      var e = navigator.userAgent.toLowerCase(),
        t = /(chrome)[ ]([\w.]+)/.exec(e) || /(webkit)[ ]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(e) || /(msie) ([\w.]+)/.exec(e) || 0 > e.indexOf("compatible") && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(e) || [];
      return {
        browser: t[1] || "",
        version: t[2] || "0"
      };
    }
  }, {
    key: "isVisible",
    value: function value(e) {
      return e && null != e.offsetParent;
    }
  }, {
    key: "getFocusableElements",
    value: function value(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        i = t.find(e, 'button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])'.concat(n, ',\n              [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(n, ',\n              input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(n, ',\n              select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(n, ',\n              textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(n, ',\n              [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(n, ',\n              [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(n)),
        o = [],
        l = !0,
        r = !1,
        a = void 0;
      try {
        for (var s, u = i[Symbol.iterator](); !(l = (s = u.next()).done); l = !0) {
          var d = s.value;
          "none" !== getComputedStyle(d).display && "hidden" !== getComputedStyle(d).visibility && o.push(d);
        }
      } catch (e) {
        r = !0, a = e;
      } finally {
        try {
          l || null == u.return || u.return();
        } finally {
          if (r) throw a;
        }
      }
      return o;
    }
  }, {
    key: "getFirstFocusableElement",
    value: function value(e, n) {
      var i = t.getFocusableElements(e, n);
      return i.length > 0 ? i[0] : null;
    }
  }, {
    key: "getLastFocusableElement",
    value: function value(e, n) {
      var i = t.getFocusableElements(e, n);
      return i.length > 0 ? i[i.length - 1] : null;
    }
  }, {
    key: "isSafari",
    value: function value() {
      return -1 !== navigator.userAgent.indexOf("Safari") && -1 === navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Chromium");
    }
  }, {
    key: "exportCSV",
    value: function value(e, t) {
      var n = new Blob([e], {
        type: "application/csv;charset=utf-8;"
      });
      if (window.navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(n, t + ".csv");else {
        var i = document.createElement("a");
        void 0 !== i.download ? (i.setAttribute("href", URL.createObjectURL(n)), i.setAttribute("download", t + ".csv"), i.style.display = "none", document.body.appendChild(i), i.click(), document.body.removeChild(i)) : (e = "data:text/csv;charset=utf-8," + e, window.open(encodeURI(e)));
      }
    }
  }, {
    key: "createInlineStyle",
    value: function value() {
      var e = document.createElement("style"),
        t = process.env.REACT_APP_CSS_NONCE;
      return t && e.setAttribute("nonce", t), document.head.appendChild(e), e;
    }
  }, {
    key: "isClickable",
    value: function value(e) {
      var t = e.nodeName,
        n = e.parentElement && e.parentElement.nodeName;
      return "INPUT" === t || "TEXTAREA" === t || "BUTTON" === t || "A" === t || "INPUT" === n || "TEXTAREA" === n || "BUTTON" === n || "A" === n || this.hasClass(e, "p-button") || this.hasClass(e.parentElement, "p-button") || this.hasClass(e.parentElement, "p-checkbox") || this.hasClass(e.parentElement, "p-radiobutton");
    }
  }], function (e, t) {
    for (var n = 0; n < t.length; n++) {
      var i = t[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }(t, e), t;
}();
e(t, "zindex", void 0), e(t, "browser", void 0), e(t, "calculatedScrollbarWidth", void 0);
export { t as default };